import {
	GET_ALL_ORDERS,
	GET_ORDER_DETAILS,
	UPDATE_ORDER
} from '../../Actions/Admin/ManageOrderAction';

const initialState = {
    orders: [],
    orderDetails:null
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_ORDERS:
			return {
				...state,
				loading: true,
				orders: action.payload
			};
		case GET_ORDER_DETAILS:
		return {
			...state,
			orderDetails: action.payload
		};
	   case UPDATE_ORDER:
		return {
			...state,
			orders: action.payload
		};
	
		default:
			return state;
	}
};
